module.exports = __webpack_public_path__ + "img/dgjg2333_2.1aa26de7.svg";